import { jsPDF } from "jspdf";
import { loadCustomFontFiraSansLight } from "../assets/fonts/FiraSans-Light-normal"; //base64 de la fuente
import { loadCustomFontFiraSansSemibold } from "../assets/fonts/FiraSans-SemiBold-normal"; //base64 de la fuente
import { loadCustomFontFiraSansRegular } from "../assets/fonts/FiraSans-Regular-normal"; //base64 de la fuente
import { loadB64Key } from "./pdfImgs";
import i18n from 'i18next';


export const downloadSecretPDF = (data) => {
  const firaSansLightB64 = loadCustomFontFiraSansLight();
  const firaSansSemiboldB64 = loadCustomFontFiraSansSemibold();
  const firaSansRegularB64 = loadCustomFontFiraSansRegular();
  const keyIMG = loadB64Key();


  const doc = new jsPDF();


  //AÑADIR FUENTES PERSONALIZADAS
  doc.addFileToVFS('FiraSans-Light-normal.ttf', firaSansLightB64);
  doc.addFileToVFS('FiraSans-SemiBold-normal.ttf', firaSansSemiboldB64);
  doc.addFileToVFS('FiraSans-Regular-normal.ttf', firaSansRegularB64);
  doc.addFont('FiraSans-Light-normal.ttf', 'FiraSans-Light', 'normal');
  doc.addFont('FiraSans-SemiBold-normal.ttf', 'FiraSans-SemiBold', 'normal');
  doc.addFont('FiraSans-Regular-normal.ttf', 'FiraSans-Regular', 'normal');




  // variables del documento
  const keyImg = keyIMG;
  const link = data.publicLink;
  const text1 = `${i18n.t("incidents:pdfIncident.secretSaveDoc")}`;
  const maxWidth1 = 160;
  const lines1 = doc.splitTextToSize(text1, maxWidth1);
  const imgWidth = 50; // Ancho de la imagen de la empresa en el pdf
  const imgHeight = 12;
  const bigFontSize = 17;
  const smallFontSize = 10;
  const stepsFontSize = 18;





  doc.addImage(keyImg, "PNG", 18, 25, 6, 6);
  doc.setFontSize(bigFontSize);
  doc.setFont("FiraSans-SemiBold", "normal");
  doc.text(`${i18n.t("incidents:pdfIncident.secretKey")}`, 27, 30, { align: 'left' });
  doc.setFontSize(smallFontSize);
  doc.text(`${i18n.t("incidents:pdfIncident.secretDontShare")}`, 185, 30, { align: 'right' });
  doc.setDrawColor(169, 169, 169)
  doc.line(18, 35, 185, 35);
  doc.setFont("FiraSans-Regular");

  doc.setFontSize(13);
  doc.setFont("FiraSans-SemiBold");
  lines1.forEach((line, i) => {
    doc.text(line, 32, 52 + i * 7, { align: 'left' });
  });
  doc.setFont("FiraSans-Regular");


  doc.setFontSize(11);
  doc.text(`${i18n.t("incidents:pdfIncident.secretFollowSteps")}: `, 32, 65, { align: 'left' });

  doc.setFontSize(stepsFontSize);
  doc.setFont("FiraSans-SemiBold");
  doc.text("1", 33, 80, { align: 'left' });
  doc.setFont("FiraSans-Regular");
  doc.setDrawColor(169, 169, 169)
  doc.setLineWidth(1);
  doc.line(40, 74, 40, 82);
  doc.setFontSize(smallFontSize);
  doc.text(`${i18n.t("incidents:pdfIncident.secretNavigate")}: `, 45, 77, { align: 'left' });
  doc.setFontSize(smallFontSize);
  doc.text(link, 45, 81);
  doc.setDrawColor(0, 0, 0)
  doc.setLineWidth(0.2)
  const textSize = doc.getTextWidth(link)
  doc.line(45, 81 + 1, 45 + textSize, 81 + 1);
  doc.link(45, 9, 50, 10, { url: link });

  doc.setFontSize(stepsFontSize);
  doc.setFont("FiraSans-SemiBold");
  doc.text("2", 33, 98, { align: 'left' });
  doc.setFont("FiraSans-Regular");
  doc.setDrawColor(169, 169, 169)
  doc.setLineWidth(1);
  doc.line(40, 92, 40, 100);
  doc.setFontSize(smallFontSize);
  doc.text(`${i18n.t("incidents:pdfIncident.secretPress")} \"${i18n.t("incidents:pdfIncident.secretCheckIncident")}\"`, 45, 98, { align: 'left' });

  doc.setFontSize(stepsFontSize);
  doc.setFont("FiraSans-SemiBold");
  doc.text("3", 33, 116, { align: 'left' });
  doc.setFont("FiraSans-Regular");
  doc.setDrawColor(169, 169, 169)
  doc.setLineWidth(1);
  doc.line(40, 110, 40, 118);
  doc.setFontSize(smallFontSize);
  doc.text(`${i18n.t("incidents:pdfIncident.secretWriteKey")}: `, 45, 115, { align: 'left' });
  doc.setFillColor(169, 169, 169);
  doc.rect(65, 125, 85, 7, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(12);
  doc.setFont("FiraSans-SemiBold");
  doc.text(data.key, 68, 130, { align: 'left' });
  doc.setFontSize(smallFontSize);
  doc.setFont("FiraSans-Regular");

  const pageWidth = doc.internal.pageSize.width;
  const imgX = (pageWidth - imgWidth + 5) / 2;

  // Calcular la posición Y para la imagen
  const imgY = doc.internal.pageSize.height - imgHeight - 10;

  doc.addImage(data.companyImage, "PNG", imgX, imgY, imgWidth, imgHeight);

  doc.save(`${i18n.t("incidents:pdfIncident.secretDocName")}.pdf`);

};

